export default "__VITE_ASSET__BGyZrkPo__"